module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "c01"
    }
  })]), _c('a', {
    attrs: {
      "id": "c01"
    }
  }, [_c('div', {
    staticClass: "centerAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "003",
      "src": "karl_9781569759561_oeb_003_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_c('b', [_vm._v("foam roller: the magic bullet?")])]), _vm._v(" "), _c('div', {
    staticClass: "atx1"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_vm._v("Foam rollers were once used exclusively in physical therapy settings. In fact, Dr. Moshé Feldenkrais was credited with being the first person to use rollers for therapeutic purposes (e.g., improving body alignment, reducing muscle tightness, teaching body awareness) in the late 1950s.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Now they’re used in yoga and Pilates classes to strengthen the body as well as relax and stretch tight muscles. They’re also available in most gyms’ stretching areas.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Some experts suggest that, if not addressed early, minor muscle imbalances (such as those tight, tender spots) can contribute to serious injuries or chronic dysfunction later on, which may require expensive therapy. Prevention is always easier and cheaper than treatment. Foam rollers are a wonderful way to address the above concerns while adding diversity and challenge to your standard exercise program.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Designing a balanced exercise routine that includes flexibility movements with strength training, cardiovascular exercise and relaxation can reduce chronic discomfort. Since foam rollers break up interwoven muscle fibers and help move oxygenated blood into those muscles, they’re an excellent vehicle with which to release those tight spots in muscles (the technical term is “myofascial release”) and return the muscles to a more optimal state. This can be done prior to exercising to improve range of motion, or after a workout to relax tight muscles and reduce soreness.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("The beauty of the roller is that it’s inexpensive and easy to use, and can be utilized to rehabilitate your body as well as prevent possible issues such as lower back pain and shin splints. "), _c('i', [_vm._v("Foam Roller Workbook")]), _vm._v(" provides you with numerous exercises to improve posture, core stability and flexibility, as well as hone dynamic balance and mindful relaxation.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-702aa3c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/karl_9781569759561_oeb_c01_r1.vue
// module id = 69
// module chunks = 0